import { combineReducers } from "redux";
import authReducer, { AuthState } from "./authReducer";

// Only the auth slice is left; hooks/useAuth keeps it in sync on sign-in and sign-out.
export interface IApplicationState {
  auth: AuthState;
}

export default combineReducers({
  auth: authReducer,
});
